//@nocheck
import React, { lazy, Suspense } from "react";
import TitleHandler from "../ARCElementTitle";
import { isInTime } from "../../lib/utils";

interface MenuItem {
  ID: number;
  parent: number | null;
  ordering: number;
  [key: string]: never;
}

interface Menu {
  list?: MenuItem[];
}

interface PropsType {
  element:
    | "menu"
    | "slider"
    | "search"
    | "objView"
    | "cart"
    | "carousel"
    | "free"
    | "cv"
    | "parameters";
  position: string;
  className?: string;
  tag: string;
  layout: string;
  isFrag: boolean;
  trashed: number | boolean;
  published?: number;
  menu?: Menu;
  showTitle: boolean;
}

interface MenuConvertedProps extends PropsType {
  sortList: MenuItem[];
}

export default function ARCElement(props: PropsType) {
  const { className, isFrag, tag = "div", trashed, published } = props;

  const OtherComponent = lazy(() =>
    import(`./${props.element}/layout/${props.layout}`).catch(() => {
      console.error("Error In", props.ID);
      return { default: FallbackComponent };
    })
  );

  const newProps = convertType(props);

  if (trashed && +trashed === 1 && isInTime(published)) {
    return null;
  }
  if (isFrag) {
    return React.createElement(
      tag,
      {},
      <Suspense fallback={<></>}>
        <OtherComponent {...newProps} />
      </Suspense>
    );
  } else {
    return React.createElement(
      "div",
      { className },
      <Suspense fallback={<></>}>
        <TitleHandler {...newProps} />
        <OtherComponent {...newProps} />
      </Suspense>
    );
  }
}

const FallbackComponent = () => {
  return <React.Fragment />;
};

function convertType(props: PropsType): PropsType | MenuConvertedProps {
  if (props.element === "menu") {
    return menuConvertor(props);
  }
  return props;
}

function menuConvertor(props: PropsType): MenuConvertedProps {
  const { menu } = props;
  let sortList: MenuItem[] = [];
  if (menu?.list) {
    // ابتدا آرایه را بر اساس ordering از بزرگ به کوچک مرتب می‌کنیم
    menu.list.sort((a: MenuItem, b: MenuItem) => b.ordering - a.ordering);

    // یک مپ برای دسترسی سریع به آبجکت‌ها بر اساس ID ایجاد می‌کنیم
    let map: Record<number, MenuItem> = {};
    menu.list.forEach(
      (item: MenuItem) => (map[item.ID] = { ...item, children: [] })
    );

    // حالا آرایه‌ی مرتب شده را پیمایش می‌کنیم و آبجکت‌ها را بر اساس رابطه‌ی پدر و فرزند سازماندهی می‌کنیم
    menu.list.forEach((item: MenuItem) => {
      if (item.parent === null) {
        sortList.push(map[item.ID]);
      } else {
        if (map[item.parent]) {
          map[item.parent].children.push(map[item.ID]);
        }
      }
    });
  }
  return { ...props, sortList };
}
